export const USER_BLOCKS_ENTITY = 'user-blocks';

export const getBlockedUsersQueryKey = () => [USER_BLOCKS_ENTITY];

/** Shared by the block mutation and `useIsMutating` so UIs can show a pending state. */
export const getBlockUserMutationKey = () => [USER_BLOCKS_ENTITY, 'block'];

export const getUserBlockedUsersQueryKey = (authUserId: string) => [USER_BLOCKS_ENTITY, 'admin', authUserId];
